module.exports = __webpack_public_path__ + "static/media/3275432.e52f2edd.svg";